export enum StateNamesEnum {
  ALLOWANCE = 'allowance',
  CORE_STATE_NAME = 'core',
  VET_STATE_NAME = 'vet',
  PATIENT_STATE_NAME = 'patient',
  CONSULTATION_STATE_NAME = 'consultation',
  PRODUCTS_STATE_NAME = 'products',
  PET_STATE_NAME = 'pet',
  SHARE_RECOMMENDATION_STATE_NAME = 'share_recommendation',
  PATIENT_PROFILE_STATE_NAME = 'patientProfile',
}
